module.exports = __webpack_public_path__ + "7cd4b6606a91f6645d1d45c34e5d215a.fbx";